<script setup="">
import { computed } from "vue";

import CampaignFooter from "@campaign-js/Components/CampaignFooter.vue";
import SocialButton from "@campaign-js/Components/SocialButton.vue";
import LogoMark from "@campaign-js/Layouts/Partials/LogoMark.vue";
import { Link } from "@inertiajs/vue3";

const props = defineProps({
  campaign: {
    type: Object,
    required: true
  },
  isMember: {
    type: Boolean,
    required: false,
    default: false
  },
  navs: {
    type: Object,
    required: true
  },
  isFreePlan: {
    type: Boolean,
    required: false,
    default: false
  }
});

const hasUtmValue = computed(() => props.campaign.settings.utm_source || props.campaign.settings.utm_medium);

const getLink = (link) => {
  if (link.type === "link") {
    if (hasUtmValue.value) {
      return `${link}?utm_source=${props.campaign.settings.utm_source}&utm_medium=${props.campaign.settings.utm_medium}`;
    }
    return link.value;
  }

  return `tel:${link.value}`;
};
</script>

<template>
  <div class="text-zinc-900">
    <div class="sticky top-0 flex h-screen w-[340px] flex-col justify-center px-0 lg:pl-2">
      <div class="flex flex-1 flex-col justify-center">
        <div>
          <div class="mt-3 flex-none tracking-tighter">
            <div class="mt-6">
              <h2 class="line-clamp-3 whitespace-pre-wrap break-all text-4xl/10 font-bold">
                <span>{{ campaign.title }}</span>
              </h2>
              <p class="mt-4 whitespace-pre-wrap text-sm opacity-80 md:text-base">{{ campaign.message }}</p>
            </div>
          </div>

          <div class="w-4/5 flex-1 overflow-y-auto scrollbar-hide sm:max-w-campaign">
            <nav class="mt-14 space-y-14">
              <div class="space-y-4">
                <Link
                  v-for="nav in navs"
                  :key="nav.name"
                  :href="nav.href"
                  class="block w-full text-2.5xl font-bold"
                  :class="[nav.current ? '' : 'opacity-50', 'text-black']"
                >
                  {{ nav.name }}
                </Link>
              </div>

              <div class="flex flex-wrap items-center gap-2">
                <template v-for="link in campaign.settings.links" :key="link.name">
                  <a
                    :href="getLink(link)"
                    :target="link.target"
                    class="relative rounded-full bg-[#FFF] px-4 py-2 text-center text-sm font-semibold shadow-soft backdrop-blur-sm transition duration-300 hover:scale-[.95] active:scale-[.95]"
                  >
                    <span>{{ link.name }}</span>
                  </a>
                </template>
                <!--end::custom-nav-->
              </div>
            </nav>
          </div>
        </div>
      </div>

      <div class="mb-4 flex-none">
        <div>
          <SocialButton :socials="campaign.settings.socials" />
        </div>
        <div class="mt-4">
          <CampaignFooter :footers="campaign.settings.footers" />
        </div>
        <div v-if="isFreePlan" class="flex-start relative text-zinc-700">
          <LogoMark />
        </div>
      </div>
    </div>
  </div>
  <!--end::campaign-->
</template>
